import ApiConstant from "../../constants/api.constants";
import api from "../api";

const getAddress = async (filter: string) => {  
    try {
        const allAddress: any = await api
        .get(ApiConstant.getCustomerAddress + filter)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error reading get all address', error);
         });
        const response = allAddress != null ? allAddress : null;        
        return response;
    }
    catch (e) {
        console.log('error in getAddress');
        return [];
    } 
}

const updateAddress = async (data: any) => {
    try {
        const updatedAddress: any = await api
        .put(ApiConstant.updateCustomerAddress, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error updating customer address', error);
         });
        const response = updatedAddress != null ? updatedAddress : null;        
        return response;
    }
    catch
    {
        console.log('error in edit address');
        return false;
    }
}

const deleteAddress = async (userId: number) => {
    try {
        const deleteAddress: any = await api
        .delete(ApiConstant.deleteUserAddress + userId)
        .then((res: any)=> {
            if(res)            
                return res.data;
            else
                return null;         
        })
        .catch(function (error: any) {
            console.error('error deleting address.', error);
        });
        const response = deleteAddress != null ? deleteAddress : null;        
        return response;
    }
    catch
    {
        console.log('error in delete customer address');
        return false;
    }
}


const AllUserAddress = async (pageNumber: number, pageSize: number) => {
    try {
      const requestData = {
        pageNumber,
        pageSize,
      };
  
      const AllAdd: any = await api
        .post(ApiConstant.GetAllAddress, requestData)
        .then((res: any) => {
          if (res) {
            return res.data;
          } else {
            return null;
          }
        })
        .catch(function (error: any) {
          console.error("Error fetching Address:", error);
        });
  
      const response = AllAdd != null ? AllAdd : null;
      return response;
    } catch (e) {
      console.log("Error in fetching address");
      return [];
    }
  };

  const fetchUserAddresses = async (
    keyword: string,
    userId: number,
    pageNumber: number,
    pageSize: number
  ) => {
    try {
      const requestData = {
        keyword,
        userId,
        pageNumber,
        pageSize,
      };
      const response: any = await api
        .post(ApiConstant.FilterByUsersAddress, requestData)
        .then((res: any) => {
          if (res) {
            return res.data;
          } else {
            return null;
          }
        })
        .catch((error: any) => {
          console.error("Error filter fetching addresses:", error);
          return null;
        });
  
      return response !== null ? response : [];
    } catch (e) {
      console.log("Error in fetching addresses filter Addresss");
      return [];
    }
  };

const customerAddressService = {
    getAddress,
    updateAddress,
    deleteAddress,
    AllUserAddress,
    fetchUserAddresses
};

export default customerAddressService;